import { getActiveAccountId } from '@auw/api-client';
import { resetChatRuntimeForLogout } from './chatStore';
import { useReboModeStore } from './reboModeStore';
import { useUIStore } from './uiStore';
import { useUserStore } from './userStore';
import { clearStoredSystemPromptSelection, useSystemPromptStore } from './systemPromptStore';
import { activeTenantKey as tenantKey, activeTenantNamespacedKey as tenantNamespacedKey } from '@auw/tenant';

const WALLPAPER_META_KEY_PREFIX = tenantKey('wallpaper');
const WALLPAPER_IMG_KEY_PREFIX = tenantKey('wallpaper_img');
const LEGACY_WALLPAPER_META_KEY = tenantKey('wallpaper');
const LEGACY_WALLPAPER_IMG_KEY = tenantKey('wallpaper_img');
const WIDGET_STORAGE_KEY_PREFIX = tenantKey('widget_canvas');
const WIDGET_SCOPED_KEYS = [
  tenantNamespacedKey('widget', 'calendar-modal'),
  tenantNamespacedKey('widget', 'email-modal'),
  tenantNamespacedKey('widget', 'dm-modal'),
  tenantNamespacedKey('widget', 'agent-modal'),
  tenantNamespacedKey('widget', 'layout-meta'),
] as const;

function removeLocalStorageKey(key: string): void {
  try {
    window.localStorage.removeItem(key);
  } catch {
    // storage access errors are non-fatal during auth reset
  }
}

function getScopedStorageKey(baseKey: string, accountId: string | null): string {
  return `${baseKey}:${accountId || 'anonymous'}`;
}

export function resetRuntimeSessionState(options?: {
  resetDarkMode?: boolean;
}): void {
  useUserStore.getState().clear();
  useSystemPromptStore.getState().reset();
  useReboModeStore.getState().setMcpApprovalMode('ask_for_approval');
  resetChatRuntimeForLogout();

  if (options?.resetDarkMode) {
    useUIStore.getState().setDarkMode(true);
  }

  useUIStore.setState({
    wallpaper: null,
    wallpaperUpdatedAt: 0,
    wallpaperAccountId: null,
    wallpaperExplicit: false,
    settingsModalOpen: false,
    settingsModalRequest: null,
  });
}

export function clearWithdrawnAccountClientState(accountId: string | null = getActiveAccountId()): void {
  clearStoredSystemPromptSelection(accountId);
  removeLocalStorageKey(getScopedStorageKey(WIDGET_STORAGE_KEY_PREFIX, accountId));
  WIDGET_SCOPED_KEYS.forEach((key) => {
    removeLocalStorageKey(getScopedStorageKey(key, accountId));
  });

  removeLocalStorageKey(getScopedStorageKey(WALLPAPER_META_KEY_PREFIX, accountId));
  removeLocalStorageKey(getScopedStorageKey(WALLPAPER_IMG_KEY_PREFIX, accountId));
  removeLocalStorageKey(LEGACY_WALLPAPER_META_KEY);
  removeLocalStorageKey(LEGACY_WALLPAPER_IMG_KEY);

  if (useUIStore.getState().wallpaperAccountId === accountId) {
    useUIStore.setState({
      wallpaper: null,
      wallpaperUpdatedAt: 0,
      wallpaperAccountId: null,
      wallpaperExplicit: false,
    });
  }
}
